import React from "react";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import EmployeeProfileTabHeader from "./EmployeeProfileTabHeader";
import EmployeePaySection from "./EmployeePaySection";
import EmployeePayrollSection from "./EmployeePayrollSection";
import EmployeeLaborAccountSection from "./EmployeeLaborAccountSection";
import EmployeeTimekeepingSection from "./EmployeeTimekeepingSection";

// Pay & Timekeeping: pay classification, pay and pay changes (admins), and
// clock-in expectations and the payroll ID (managers and admins).
export default function EmployeeProfilePayTab({
  selectedTeamMemberData,
  homeStore,
  fetchStoreTeamMember,
  relatedTeamMembersData,
  canManagePay,
}) {
  return (
    <div className="max-w-5xl mx-auto">
      <EmployeeProfileTabHeader
        icon={MonetizationOnIcon}
        title="Pay & Timekeeping"
        subtitle={canManagePay ? "Pay classification, pay, timekeeping and payroll details." : "Timekeeping and payroll details."}
      />
      <div className="space-y-6">
        {canManagePay && (
          <EmployeePaySection
            selectedTeamMemberData={selectedTeamMemberData}
            homeStore={homeStore}
            fetchStoreTeamMember={fetchStoreTeamMember}
            relatedTeamMembersData={relatedTeamMembersData}
          />
        )}
        <EmployeeTimekeepingSection
          selectedTeamMemberData={selectedTeamMemberData}
          homeStore={homeStore}
          fetchStoreTeamMember={fetchStoreTeamMember}
        />
        <EmployeeLaborAccountSection
          selectedTeamMemberData={selectedTeamMemberData}
          homeStore={homeStore}
          fetchStoreTeamMember={fetchStoreTeamMember}
        />
        <EmployeePayrollSection
          selectedTeamMemberData={selectedTeamMemberData}
          homeStore={homeStore}
          fetchStoreTeamMember={fetchStoreTeamMember}
        />
      </div>
    </div>
  );
}
